import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=7145e9cc&lang=pug"
import script from "./StatusIcon.vue?vue&type=script&lang=ts"
export * from "./StatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=7145e9cc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports